// Divako handwriting loader — animated "divako.io" wordmark drawn
// left-to-right, held, then erased. Ported from the application repo's
// Divako loader (template/default/divako-loader-symbol.php — the
// #divako-handwrite-mark symbol — plus css/divako-loader.css), where it
// backs the DataTables processing overlay. Styled by .divako-handwrite /
// .dv-write in index.css.

import type { CSSProperties, ReactElement } from 'react';

const PATHS: { d: string; delay: string }[] = [
  {
    d: 'M 151.821 24.742 C 151.786 26.22 151.896 27.693 152.137 29.15 L 151.924 29.15 C 149.958 26.347 147.328 24.076 144.269 22.537 C 141.21 20.999 137.818 20.242 134.396 20.334 C 120.801 20.334 109.964 31.299 109.964 48.61 C 109.964 65.707 120.797 76.889 134.716 76.889 C 138.406 76.912 142.032 75.923 145.197 74.027 C 148.363 72.131 150.947 69.402 152.668 66.138 L 152.878 66.138 C 152.661 67.377 152.592 68.645 152.668 69.901 L 152.878 75.494 L 164.775 75.494 L 164.775 0.003 L 151.821 0.003 L 151.821 24.742 Z',
    delay: '0s',
  },
  {
    d: 'M 136.841 65.721 C 128.232 65.721 122.288 58.627 122.288 48.624 C 122.288 38.517 128.239 31.53 136.841 31.53 C 143.959 31.53 151.5 37.012 151.5 48.624 C 151.5 60.235 143.959 65.721 136.841 65.721 Z',
    delay: '.12s',
  },
  {
    d: 'M 191.054 0.165 C 189.628 0.217 188.249 0.686 187.088 1.514 C 185.927 2.342 185.034 3.494 184.522 4.825 C 184.009 6.156 183.899 7.608 184.205 9.001 C 184.511 10.395 185.219 11.667 186.242 12.661 C 187.265 13.655 188.558 14.327 189.959 14.593 C 191.361 14.858 192.809 14.707 194.125 14.156 C 195.441 13.606 196.566 12.681 197.361 11.496 C 198.155 10.311 198.585 8.92 198.595 7.493 C 198.649 6.498 198.489 5.503 198.127 4.575 C 197.764 3.647 197.206 2.808 196.492 2.113 C 195.777 1.419 194.922 0.886 193.984 0.55 C 193.046 0.214 192.047 0.083 191.054 0.165 Z',
    delay: '.24s',
  },
  {
    d: 'M 197.531 21.75 L 184.573 21.75 L 184.573 75.504 L 197.531 75.504 L 197.531 21.75 Z',
    delay: '.36s',
  },
  {
    d: 'M 244.481 40.238 C 242.253 45.938 239.808 53.035 238.107 57.549 C 234.494 47.012 228.971 33.789 224.195 21.736 L 210.596 21.736 L 234.281 76.465 L 241.929 76.465 L 265.618 21.736 L 252.022 21.736 L 244.481 40.238 Z',
    delay: '.48s',
  },
  {
    d: 'M 294.127 20.341 C 287.545 20.187 281.011 21.51 275.008 24.215 L 275.008 36.037 C 280.225 33.086 286.116 31.532 292.109 31.526 C 299.861 31.526 304.751 34.212 304.751 42.06 L 304.751 44.102 C 284.141 41.199 271.289 47.649 271.289 60.876 C 271.289 71.207 278.724 76.895 288.163 76.895 C 291.806 76.838 295.363 75.773 298.439 73.818 C 301.514 71.863 303.988 69.095 305.587 65.821 L 305.797 65.821 C 305.581 67.171 305.512 68.541 305.587 69.908 L 305.797 75.501 L 317.588 75.501 L 317.588 41.409 C 317.588 27.979 309.833 20.338 294.113 20.338',
    delay: '.6s',
  },
  {
    d: 'M 291.049 66.689 C 290.102 66.776 289.147 66.662 288.247 66.353 C 287.348 66.044 286.525 65.548 285.832 64.896 C 285.138 64.245 284.592 63.454 284.227 62.576 C 283.863 61.698 283.689 60.752 283.717 59.801 C 283.717 53.675 289.878 49.471 304.43 51.847 C 304.547 55.569 303.219 59.192 300.724 61.957 C 298.23 64.722 294.763 66.415 291.049 66.682 L 291.049 66.689 Z',
    delay: '.72s',
  },
  {
    d: 'M 334.18 0.003 L 334.18 75.49 L 346.921 75.49 L 346.921 59.901 L 354.676 51.189 L 369.652 75.49 L 384.418 75.49 L 364.555 44.309 L 383.037 21.729 L 367.954 21.729 L 347.134 46.247 L 347.134 0 L 334.18 0.003 Z',
    delay: '.84s',
  },
  {
    d: 'M 418.138 20.348 C 412.527 20.259 407.016 21.842 402.307 24.895 C 397.598 27.948 393.904 32.333 391.695 37.491 C 389.485 42.65 388.861 48.35 389.901 53.864 C 390.941 59.379 393.599 64.46 397.535 68.459 C 401.472 72.459 406.509 75.197 412.006 76.325 C 417.504 77.453 423.213 76.92 428.406 74.793 C 433.599 72.667 438.043 69.043 441.17 64.383 C 444.298 59.724 445.968 54.239 445.969 48.627 C 446.106 44.914 445.483 41.212 444.139 37.748 C 442.795 34.284 440.757 31.131 438.152 28.482 C 435.547 25.832 432.428 23.744 428.986 22.345 C 425.544 20.946 421.852 20.267 418.138 20.348 Z',
    delay: '.96s',
  },
  {
    d: 'M 418.138 65.721 C 409.322 65.721 402.642 58.734 402.642 48.624 C 402.642 38.513 409.333 31.53 418.138 31.53 C 427.06 31.53 433.634 38.52 433.634 48.624 C 433.634 58.73 427.05 65.721 418.138 65.721 Z',
    delay: '1.08s',
  },
];

export default function DivakoHandwrite({ size = 160 }: { size?: number }): ReactElement {
  return (
    <span
      className="divako-handwrite"
      style={{ '--size': `${size}px` } as CSSProperties}
      role="status"
      aria-label="Loading"
    >
      <svg viewBox="109 0 337 78" aria-hidden="true">
        {PATHS.map((p) => (
          <path
            key={p.delay}
            className="dv-write"
            pathLength={1}
            d={p.d}
            style={{ animationDelay: p.delay }}
          />
        ))}
      </svg>
    </span>
  );
}
